import { render, staticRenderFns } from "./invoice-pdf-card.vue?vue&type=template&id=36a7fc68&scoped=true&"
import script from "./invoice-pdf-card.vue?vue&type=script&lang=ts&"
export * from "./invoice-pdf-card.vue?vue&type=script&lang=ts&"
import style0 from "./invoice-pdf-card.vue?vue&type=style&index=0&id=36a7fc68&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36a7fc68",
  null
  
)

export default component.exports